export enum ClassType {
  EasySpinning = "Easy Spinning",
  RegularSpinning = "Spinning",
  PrivateSpinning = "Privé Spinning",
}
